import React from 'react';
import { useIntl } from 'react-intl';
import { StyledLink } from './Logo.styles';
import { LogoSvg } from './LogoSvg';
const A11Y_LOGO_KEY = 'A11Y_LOGO';
const Logo = ({ butterfly = false, className, homeLink = '/', dataQa, variant, size, }) => {
    const intl = useIntl();
    return (React.createElement(StyledLink, { ...(homeLink && { to: homeLink }), title: intl.formatMessage({ id: A11Y_LOGO_KEY }), className: className, "data-qa": dataQa },
        React.createElement(LogoSvg, { butterfly: butterfly, variant: variant, size: size })));
};
export { Logo };
//# sourceMappingURL=Logo.js.map